import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'includedCategory',
    pure: false
})
export class IncludedCategoryPipe implements PipeTransform {
    categoryIsIncluded(category, streamMap) {
        return !!streamMap[category.id] ||
                category.subcategories.map(subcat => !!streamMap[subcat.id]).reduce((acc, val) => acc || val, false);
    }

    transform(allCategories: any, streamMap: any): any {
        return allCategories ?
            allCategories.filter(category => this.categoryIsIncluded(category, streamMap)) :
            allCategories;
    }
}
